import { gql } from '@apollo/client';

/**
 * Mutation para establecer un feature flag en un tenant específico
 * Solo SuperAdmin
 */
export const SET_CONFIG_FOR_TENANT = gql`
  mutation SetConfigForTenant($tenantId: ID!, $key: String!, $value: String!) {
    setConfigForTenant(tenantId: $tenantId, key: $key, value: $value) {
      id
      settings
      tenantId
      updatedAt
    }
  }
`;

/**
 * Mutation para eliminar un feature flag de un tenant específico
 * Solo SuperAdmin
 */
export const DELETE_CONFIG_FOR_TENANT = gql`
  mutation DeleteConfigForTenant($tenantId: ID!, $key: String!) {
    deleteConfigForTenant(tenantId: $tenantId, key: $key) {
      id
      settings
      tenantId
      updatedAt
    }
  }
`;

/**
 * Mutation para crear un feature flag en el catálogo global
 * Solo SuperAdmin
 */
export const CREATE_FEATURE_FLAG = gql`
  mutation CreateFeatureFlag($input: CreateFeatureFlagInput!) {
    createFeatureFlag(input: $input) {
      id
      key
      description
      defaultValue
      isActive
    }
  }
`;

/**
 * Mutation para eliminar un feature flag del catálogo global
 * Solo SuperAdmin
 */
export const DELETE_FEATURE_FLAG = gql`
  mutation DeleteFeatureFlag($key: String!) {
    deleteFeatureFlag(key: $key) {
      id
      key
    }
  }
`;

/**
 * Mutation para editar un feature flag del catálogo global
 * (descripción, valor por defecto y/o activo). Solo SuperAdmin
 */
export const UPDATE_FEATURE_FLAG = gql`
  mutation UpdateFeatureFlag($key: String!, $input: UpdateFeatureFlagInput!) {
    updateFeatureFlag(key: $key, input: $input) {
      id
      key
      description
      defaultValue
      isActive
    }
  }
`;
